module.exports = {
  initDataPath: 'web/initData',
  submitMemberFormPath: 'web/submitMemberForm',
  submitEventFormPath: 'web/submitEventForm',
  searchPostListPath: 'web/searchPostList',
  searchMemberListPath: 'web/searchMemberList',
}
